// Core packages
import { Component, OnInit } from '@angular/core';

// Third party packages

// Custom packages
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss']
})
export class PublicFooterComponent implements OnInit {
  year: number = new Date().getFullYear();

  constructor(public configService: ConfigService) { }

  ngOnInit() {
  }

}
